import { render } from "./BillingInformation.vue?vue&type=template&id=9b0c98a6"
import script from "./BillingInformation.vue?vue&type=script&lang=js"
export * from "./BillingInformation.vue?vue&type=script&lang=js"

import "./BillingInformation.vue?vue&type=style&index=0&id=9b0c98a6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/BillingInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b0c98a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b0c98a6', __exports__)) {
    console.log('reload')
    api.reload('9b0c98a6', __exports__)
  }
  
  module.hot.accept("./BillingInformation.vue?vue&type=template&id=9b0c98a6", () => {
    console.log('re-render')
    api.rerender('9b0c98a6', render)
  })

}


export default __exports__